export const MESSAGES_PER_PAGE = 20;
